import type { RouterOutputs } from '../../trpc'

/**
 * The planner's enums as the configuration screens offer them. Typed off the
 * router's outputs, so an enum widened in the API stops these compiling instead
 * of a select silently missing the new value.
 */

export type PlanningGroup = RouterOutputs['configuration']['listPlanMachines'][number]['planningGroup']
export type MachineFamily = RouterOutputs['configuration']['listQualityRules']['rules'][number]['machineFamily']
export type SpecialScheduleKind = RouterOutputs['configuration']['listSpecialSchedule']['recipes'][number]['kind']

const PLANNING_GROUP_LABEL: Record<PlanningGroup, string> = {
  Olla: 'Olla',
  Horno: 'Horno',
  CP: 'CP',
  Manual: 'Manual',
  Remojo: 'Remojo',
}

/** In the order the planner and the kitchen talk about them. */
export const PLANNING_GROUPS: Array<PlanningGroup> = ['Olla', 'Horno', 'CP', 'Manual', 'Remojo']

export const PLANNING_GROUP_OPTIONS = PLANNING_GROUPS.map((group) => ({ value: group, label: PLANNING_GROUP_LABEL[group] }))

export const isPlanningGroup = (value: string): value is PlanningGroup => value in PLANNING_GROUP_LABEL

const MACHINE_FAMILY_LABEL: Record<MachineFamily, string> = { Basket: 'Basket', Vario: 'Vario', Fuego: 'Fuego' }

export const isMachineFamily = (value: string): value is MachineFamily => value in MACHINE_FAMILY_LABEL

export const MACHINE_FAMILY_OPTIONS = Object.keys(MACHINE_FAMILY_LABEL)
  .filter(isMachineFamily)
  .map((family) => ({ value: family, label: MACHINE_FAMILY_LABEL[family] }))

export const SPECIAL_SCHEDULE_LABEL: Record<SpecialScheduleKind, string> = {
  nocturnal: 'Nocturna',
  weekend: 'Fin de semana',
}

export const isSpecialScheduleKind = (value: string): value is SpecialScheduleKind => value in SPECIAL_SCHEDULE_LABEL

export const SPECIAL_SCHEDULE_OPTIONS = Object.keys(SPECIAL_SCHEDULE_LABEL)
  .filter(isSpecialScheduleKind)
  .map((kind) => ({ value: kind, label: SPECIAL_SCHEDULE_LABEL[kind] }))
